import { AuthConsumer } from '@eggplant/context'
import { DataRequest } from '@eggplant/data-request'
import type { Error } from '@eggplant/types'
import type { SauceLabProps } from './types'

const AuthenticatedSauceLabDataRequest = ({
  userName,
  apiKey,
  connectionId,
  sutId,
  url,
  onSuccess,
  onError,
  children,
  shortErrorMessage
}: SauceLabProps) => (
  <AuthConsumer>
    {
      ({
        authToken,
        onAuthReject
      }) => {
        const handleError = (error: Error) => {
          const isAuthError =
            error.status &&
            error.status.toString().includes('401')

          if (isAuthError && authToken) onAuthReject()
        }

        const sauceLabHeaders = !!userName && !!apiKey
          ? {
            'X-SauceLabs-User': userName,
            'X-SauceLabs-APIKey': apiKey
          }
          : undefined

        const extraHeaders = {
          Authorization: `Bearer ${authToken}`,
          ...sauceLabHeaders
        }

        const params = apiKey === undefined
          ? {
            connection_id: connectionId,
            sut_id: sutId
          }
          : undefined

        return (
          <DataRequest
            children={children}
            extraHeaders={extraHeaders}
            method='get'
            onError={onError || handleError}
            onSuccess={onSuccess}
            params={params}
            shortErrorMessage={shortErrorMessage}
            url={url}
          />
        )
      }
    }
  </AuthConsumer>
)

export default AuthenticatedSauceLabDataRequest
